import { Page } from '@react-pdf/renderer';

import { ReactNode } from 'react';

import { CompType } from '@aloft/toolkit-shared';
import { pageStyles } from '../styles.ts';
import { Header } from './Header.tsx';

export const Tkv2PDFPage = ({
  title,
  address,
  children,
  badge,
}: {
  title?: string;
  address: string;
  children: ReactNode;
  badge?: CompType;
}) => (
  <Page size="A4" style={pageStyles.page} wrap>
    <Header title={title} address={address} badge={badge} />
    {children}
  </Page>
);
